<template>
  <div>
    <base-fieldset>
      <base-input v-model.trim="tabletName" size="sm" label="name" clearable />
    </base-fieldset>

    <base-fieldset>
      <CompanySelect :filterArray="tabletCompanyFilter" size="xs" />
    </base-fieldset>

    <base-fieldset>
      <base-input v-model.trim="androidID" size="sm" label="android_id" clearable />
    </base-fieldset>
    <base-fieldset>
      <label class="text-xs font-semibold">Active Status</label>
      <div class="relative my-3 space-y-5 text-sm flex flex-col">
        <base-radio
          v-for="option in status"
          :key="option.label"
          v-model="tabletActive"
          :value="option.value"
          :label="option.label"
          name="tabletActive"
        />
      </div>
    </base-fieldset>
  </div>
</template>

<script>
import {
  BaseButtonIcon,
  BaseButton,
  BaseIcon,
  BaseInput,
  BaseFieldset,
  BaseRadio,
  BaseModal,
  BaseDropdown2,
} from '@/components/base'

import CompanySelect from '@/components/shared/CompanySelect.vue'

import _isEmpty from 'lodash-es/isEmpty'

export default {
  name: 'TabletsFilter',
  components: {
    BaseIcon,
    BaseInput,
    BaseButton,
    BaseFieldset,
    BaseButtonIcon,
    BaseRadio,
    BaseModal,
    CompanySelect,
    BaseDropdown2,
  },

  props: {
    mobile: {
      type: Boolean,
      default: false,
    },
  },

  data() {
    return {
      tabletCompanyFilter: this.$route.query.company || [],
      isVisible: false,
      androidID: this.$route.query.android_id || '',
      tabletActive: this.$route.query.is_active || '',
      tabletName: this.$route.query.tabletName || '',
      status: [
        {label: 'all', value: ''},
        {label: 'active', value: 'true'},
        {label: 'inactive', value: 'false'},
      ],
    }
  },
  watch: {
    $route(n, o) {
      if (_isEmpty(n.query)) {
        this.reset()
      }
    },
    async tabletName(n, o) {
      if (this.mobile) {
        return
      }
      await this.$store.dispatch('app/filterProp', {value: n, name: 'tabletName'})
    },
    async tabletCompanyFilter(n, o) {
      if (this.mobile) {
        return
      }
      this.$store.dispatch('app/filterProp', {value: n, name: 'company'})
    },
    async androidID(n, o) {
      if (this.mobile) {
        return
      }
      await this.$store.dispatch('app/filterProp', {value: n, name: 'android_id'})
    },
    async tabletActive(n, o) {
      if (this.mobile) {
        return
      }
      this.$store.dispatch('app/filterProp', {
        value: n,
        name: 'is_active',
      })
    },
  },
  methods: {
    showCompanyName(value) {
      const index = this.$store.getters['companies/list'].findIndex(row => +row['id'] === +value)
      return this.$store.getters['companies/list'][index]['name']
    },

    submit() {
      let filters = {
        value: [this.tabletName, this.tabletCompanyFilter, this.androidID, this.tabletActive],
        name: ['tabletName', 'company', 'android_id', 'is_active'],
      }
      this.$store.dispatch('app/filterProp', filters)
    },

    reset() {
      this.tabletCompanyFilter = []
      this.androidID = ''
      this.tabletActive = ''
      this.tabletName = ''
      this.$router.push({ name: 'Tablets', query: {} })
    },
  },
}
</script>

<style scoped></style>
